export default {"src":"/_next/static/media/IRT.45e010a7.svg","height":18,"width":18};